import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { isAuthenticatedUserSelector, isLoadingUserSelector } from 'store/selectors/userSelectors';
import { updateSettingsByKeyAction } from 'store/actions/settingsActions';
import { ESettingsKey } from 'store/reducers/settingsReducer/settingsTypes';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { addShopifyStoreRequest } from 'api/requests/storesRequests';
import { collectSearchParams } from 'utils/collectSearchParams';
import { setCookie } from 'utils/cookies';
import { SettingsTabPaths } from 'components/Settings/constants';
import { COOKIE_KEYS, STORAGE_KEYS } from 'utils/constants/constants';
import { ERoutePaths } from 'types/routes/enums';

export default function() {
  const dispatch = useDispatch();
  const { location: { search, pathname }, push } = useHistory();
  const isAuthenticated = useTypedSelector(isAuthenticatedUserSelector);
  const isUserLoading = useTypedSelector(isLoadingUserSelector);
  const query = new URLSearchParams(search);

  useEffect(() => {
    setCookie(COOKIE_KEYS.sessionSearch, search);

    if (pathname === ERoutePaths.ShopifyInstallAppPath) {
      const { shop } = collectSearchParams(query);

      addShopifyStoreRequest(shop);
    }

    if (!isUserLoading) {
      if (pathname === ERoutePaths.ShopifyCallback) {
        if (isAuthenticated) {
          const { code: shopifyCode, shop: url } = collectSearchParams(query);

          dispatch(updateSettingsByKeyAction({ shopifyCode, url }, ESettingsKey.StoreSettings, true));
          localStorage.removeItem(STORAGE_KEYS.fromShopifySocial);
          push(`${ERoutePaths.Settings}?${SettingsTabPaths.MyStore}`);
        } else {
          localStorage.setItem(STORAGE_KEYS.fromShopifySocial, JSON.stringify(collectSearchParams(query)));
          push(ERoutePaths.Login);
        }
      }
    }
  }, [isAuthenticated, isUserLoading]);
};
